import { render } from "./UnorderedList.vue?vue&type=template&id=350ea435&scoped=true"
import script from "./UnorderedList.vue?vue&type=script&lang=js"
export * from "./UnorderedList.vue?vue&type=script&lang=js"

import "./UnorderedList.vue?vue&type=style&index=0&id=350ea435&scoped=true&lang=css"

import exportComponent from "/builds/pazzei/pazzei-landing/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-350ea435"]])

export default __exports__